var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    {
      staticClass: "tip",
      class: {
        message: _vm.message,
        link: _vm.link,
        warning: _vm.type == "warning"
      }
    },
    [
      _vm.message || _vm.link || _vm.type == "warning"
        ? _c(
            "a",
            {
              style: {
                cursor: _vm.link ? "pointer" : "help"
              },
              attrs: {
                "data-toggle": "tooltip",
                "data-placement": _vm.placement || "auto",
                "data-container": "body",
                title: _vm.message,
                href: _vm.link,
                target: "_blank"
              }
            },
            [
              _vm.link
                ? _c("i", { staticClass: "fa fa-graduation-cap" })
                : _vm.type == "warning"
                  ? _c("i", { staticClass: "fa fa-exclamation-triangle" })
                  : _c("i", { staticClass: "fas fa-lightbulb" })
            ]
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3d4a67d4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3d4a67d4","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/tip.vue
// module id = 654
// module chunks = 72